import type {BigCalendarEvent} from 'platform/big-calendar';

import type {OutlookCalendarEvent} from '../types/OutlookCalendarEvent';

export function isOutlookCalendarEvent(event: BigCalendarEvent): event is OutlookCalendarEvent {
  return event.eventType === 'outlookEvent';
}
